import axios from 'axios';
import { processProductList } from './processingData';
// import host from './baseUrl'

// const request = new axios({
//   baseURL: '//guigui.thinkerx.com'
// });
export function generateRequestWithHost(request) {
  return {
    // 提交加入服务商和云工厂的申请
    submitApplyForServiceAndFactory: (url, payload) => {
      return request.post(url, payload).then((res) => {
        if (res.data.status == 1) {
          return '';
        } else {
          return Promise.reject(res.data.msg);
        }
      }, () => {
        return Promise.reject('网络错误，请稍后重试');
      });
    },

    // 获取服务商经营项目
    getServiceTypeOptions: () => {
      return request.get('/py/erp/get_outlets_project_setting').then((res) => {
        const result = {};
        if (res.data.status == 1) {
          const data = res.data.data;
          const keys = Object.keys(data);
          let standardKey = '';
          keys.forEach((key) => {
            console.log('key: ', key);
            switch (key) {
              case '定制家具':
                standardKey = 'furniture';
                break;
              case '定制门窗':
                standardKey = 'doorwindow';
                break;
              case '定制木门':
                standardKey = 'wooddoor';
                break;
              default:
                break;
            }
            result[standardKey] = data[key];
          });
          console.log('result1: ', result);
        }
        console.log('result2: ', result);
        return result;
      }).catch(() => {
        return Promise.resolve({});
      })
    },
    // 获取云工厂经营项目
    getFactoryTypeOptions: () => {
      return request.get('/py/erp/get_factory_project_setting').then((res) => {
        if (res.data.status == 1) {
          return res.data.data;
        } else {
          return {};
        }
      }).catch(() => {
        return Promise.resolve([]);
      })
    },
    // 或取我是谁的员工
    getStaffHasMe: (uid) => {
      return request.post('/guigui/contact/getStaffHasMe',{
        uid,
      }).then(res => {
        if(res.data){
          return res.data.data
        }
      })
    },
    // 计算报价表
    getQuoteWithTableInfo: (uid,roomId) => {
      let roomIdList = roomId.filter(function(item,index,array){
          return (index>0);
      });
      return request.post(`/py/quote_with_table`,{
        uid,
        rids:roomIdList,
        // cur_tab:"expand",
        // display_zero:false,
        // combine_quote:false,
        // disable_shadow_color_mark:false
      }).then(res => {
        console.log('要加入的柜柜订单',res)
        if(res.data.status == 1){
          return res.data.data
        }else{
          return false
        }
      })
    },
    getBill: (supplierId, billId, uid) => {
      return request.post(`/py/erp/get_stock_bill`, {
        supplier_id: supplierId,
        stock_id: billId,
        uid
      }).then((res) => {
        if (res.data.data) {
          return res.data.data.stock_data[0];
        }
      })
    },
    getBillList: (uid, supplierId, type, page, limit) => {
      return request.post(`/py/erp/get_stock_bill`, {
        supplier_id: supplierId,
        order_type: type,
        uid,
        page,
        limit,
      }).then((res) => {
        if (res.data.data) {
          return {
            data: res.data.data.stock_data,
            total: res.data.data.total
          };
        }
      })
    },
    getObjectList: (uid, supplierId, keyValue, page, usage) => {
      keyValue.limit = keyValue.limit || 20;
      const query = [];
      let newHost = `/py/erp/get_product_list`;
      for (let key in keyValue) {
        // console.log('keyvalue: ', keyValue);
        if (key == 'class' && (keyValue[key] == '画册' || keyValue[key] == '色卡')) {
          newHost = `/py/erp/get_product_album`
        }
        if (keyValue[key]) {
          // 对应搜索关键词不为空时，才把关键词加入query字符串中
          query.push(`${key}=${keyValue[key]}`);
        }
      }
      if (usage) {
        query.push(`usage=${usage}`) // 用于购物车的请求，传入usage参数，控制不让0价格的商品返回到列表中
      }
      return request.get(`${newHost}?uid=${uid}&supplier_id=${supplierId}${query.length !==0 ? '&' : ''}${query.join('&')}&page=${page}`).then((res) => {
        if (res.data.data) {
          const count = res.data.data.total || 0;
          const list = processProductList(res.data.data.list);
          return {
            count,
            list
          }
        }
      })
    },
    saveBill: (payload) => {
      return request.post(`/py/erp/commodity_storage`, payload).then((res) => {
        if (res.data.status == 1) {
          return true;
        } else {
          return false;
        }
      })
    },
    getSupplierInfo: (payload) => {
      let data;
      if (payload.uid) {
        data = {
          uid: payload.uid
        }
      } else {
        data = {
          id: payload.id
        }
      }
      return request.post(`/guigui/cloudStorage/getSupplierInfo`, data).then((res) => {
        return res.data.data;
      })
    },
    autoLogin: (p, en) => {
      let phone=Base64.decode(decodeURIComponent(p))
      return request.get(`/system/wechat_app/user_info?phone=${phone}`).then((res) => {
        return res.data.data;
      });
    },
    getEnp: () => {
      let userInfo = window.localStorage.getItem('data');
      if (userInfo) {
        return request.post(`/system/eggrj/getEnP`, {
          phone: userInfo.phone,
			    uid: userInfo.id
        }).then((res) => {
          if (res.data.data) {
            return res.data.data;
          } else {
            return '';
          }
        });
      } else {
        return Promise.resolve('');
      }
    },
    submitOrder: (payload) => {
      return request.post(`/py/erp/create_cloud_order_new`, payload).then((res) => {
        if (res.data.status == 1) {
          return res.data.data;
        } else {
          throw Error(res.data.data);
        }
      })
    },
    addManualOrder: (payload) => {
      return request.post(`/py/erp/add_manual_order`, payload).then((res) => {
        if (res.data.status == 1) {
          return res.data.data;
        } else {
          throw Error(res.data.data);
        }
      })
    },
    editManualOrder: (payload) => {
      return request.post(`/py/erp/supplier_update_order`,payload).then(res => {
        console.log(res)
    
        if(res.data.status == 1){
          return res.data.data;
        }else{
          throw Error(res.data.data);
        }
      })
    },
    getPaymentLink: (payload) => {
      return request.post(`/py/erp/create_payment_new`, payload).then((res) => {
        if (res.data.status == 1) {
          return res.data.data;
        }
      })
    },
    getOrderStatus: (payload) => {
      return request.post(`/py/erp/check_order_status`, payload).then((res) => {
        console.log(res.data.status)
        if (res.data.status == 1) {
          return res.data.data;
        }
      })
    },
    getBasicMaterialList: (userInfo, supplierInfo) => {
      let query = `uid=${userInfo.id}&setting_type=plank_setting`
      if (supplierInfo) {
        query = `${query}&supplier_id=${supplierInfo.id}`
      }
      return request.get(`/py/erp/get_supplier_setting?${query}`).then((res) => {
        if (res.data.status == 1) {
          return res.data.data;
        }
      })
    },
    getClassList: (userInfo, supplierInfo) => {
      let query = `uid=${userInfo.id}&project=${encodeURIComponent('板材')}`
      if (supplierInfo) {
        query = `${query}&supplier_id=${supplierInfo.id}`
      }
      return request.get(`/py/erp/get_brand_list?${query}`).then((res) => {
        if (res.data.status == 1) {
          return res.data.data;
        }
      });
    },
    getFilterOptions: (uid, sid, keyValue) => {
      console.log('sdas',keyValue)
      keyValue['uid'] = uid
      keyValue['supplier_id'] = sid
      return request.post("/py/erp/get_product_property",keyValue,res => {
        if (res.data.status == 1) {
          console.log('get_product_property:',res.data.data)
          return res.data.data;
        }
      })
      // const query = [`uid=${uid}`, `supplier_id=${sid}`];
      // for (let key in keyValue) {
      //   console.log('get object list: ', keyValue);
      //   if (keyValue[key]) {
      //     // 对应搜索关键词不为空时，才把关键词加入query字符串中
      //     query.push(`${key}=${keyValue[key]}`);
      //   }
      // }
      // console.log('过滤数据传参：',query,keyValue)
      // return request.get(`/py/erp/get_class_list?${query.join('&')}`).then((res) => {
      //   if (res.data.status == 1) {
      //     return res.data.data;
      //   }
      // })
    },
    getClientList: (uid,staffId=0,page) => {
      let payload = {
        uid,
        type: -1,
        // page,
        // limit:50,
        // version:1
      }
      if(staffId){
        payload.staff_id = staffId
      }
      return request.post(`/guigui/contact/customer_list`, payload).then((res) => {
        if (res.data.status == 1) {
          console.log('客户列表1111',res)
          return res.data.data;
        } else {
          return [];
        }
      })
    },
    getSupplierList: (uid, search_key) => {
      const payload = {
        page: 1,
        limit: 500, // 获取最大值，用户大多数情况会直接使用搜索，不会一项一项看，不用担心数据不全
        uid,
        search_key
      }
      return request.post(`/py/erp/supplier_management_get_vendor`, payload).then((res) => {
        if (res.data.status == 1) {
          return res.data.data.res;
        } else {
          return [];
        }
      })
    },
    sellerBuyerBindOrderId: (payload) => {
      return request.post(`/py/erp/bind_order_id`,{
        commodity_list:payload
      }).then(res => {
        return res
      })
    
    },
    getSellerAndBuyerOrderDetail: (payload) => {
      return request.post(`/py/erp/search_order`,payload).then(res => {
        return res
      })
    },
    // 根据ggid获取板件信息
    getPlankOrderInfo: (payload) => {
      let post_url;
      if(Array.from(payload)[0] == '÷'){
        payload = payload.split('÷')[1]
      }
      post_url = `/py/applet_parse_QRcode?ggid=${payload}`;
      return request.get(post_url).then(res => {
        return res
      })
    },
    // 获取所有包装箱以及包中板件(右边的模块)
    getPcPackList: (payload) => {
      return request.get(`/py/pc_get_pack_list`, payload).then(res => {
        return res
      })
    },
    // 获取项目任务列表(左边的模块)
    getPcTaskList: (payload) => {
      return request.get(`/py/pc_get_task_list`, payload).then(res => {
        return res
      })
    },
    // 获取项目所有板件列表(中间的模块)
    getPcPlankList: (payload) => {
      return request.get(`/py/pc_get_plank_list`, payload).then(res => {
        return res
      })
    },
    // 检查板件是否打包
    CheckPcPlankStatus: (payload) => {
      return request.post(`/py/pc_check_plank_status`, payload).then(res => {
        return res
      })
    },
    // 板件打包
    packPcPlank: (payload) => {
      return request.post(`/py/pc_pack_plank`, payload).then(res => {
        return res
      })
    },
    // 手动导入订单
    addPackOrder: (payload) => {
      return request.post(`/py/pc_pack_add_order`, payload).then(res => {
        return res
      })
    },
    // 搜索板件
    searchPcPlankInfo: (payload) => {
      return request.post(`/py/pc_search_plank_info`, payload).then(res => {
        return res
      })
    },
    // 完成此单
    finishPcTask: (payload) => {
      return request.post(`/py/pc_finish_task`, payload).then(res => {
        return res
      })
    },
    // 打成一包
    finishPcPack: (payload) => {
      return request.post(`/py/pc_finish_pack`, payload).then(res => {
        return res
      })
    },
    // 删除包装箱中已打包板件
    removePcPackPlank: (payload) => {
      return request.post(`/py/pc_remove_plank`, payload).then(res => {
        return res
      })
    },
    getInventoryBill: (supplierId, billId, uid) => {
      // return axios.post(`${host}/py/erp/get_stock_bill`, {
      return request.post(`/py/erp/get_inventory`, {
        supplier_id: supplierId,
        inventory_id: billId,
        uid
      }).then((res) => {
        if (res.data.data) {
          return res.data.data;
        }
      });
    },
    getStaffList: (payload) => {
      return request.get('/guigui/contact/getStaffList', payload).then((res) => {
        return res.data;
      });
    },
    addInventoryBill: (payload) => {
      return request.post(`/py/erp/add_inventory`, payload).then((res) => {
        if (res.data.status == 1) {
          return true;
        } else {
          return false;
        }
      })
    },
    updateInventoryBill: (payload) => {
      return request.post(`/py/erp/update_inventory`, payload).then((res) => {
        if (res.data.status == 1) {
          return true;
        } else {
          return false;
        }
      })
    },
    getObjectListNew: (uid, supplierId, keyValue, page, usage) => {
      // console.log('请求入参',keyValue)
      keyValue.limit = keyValue.limit || 20;
      const query = [];
      let newHost = `/py/erp/get_product_list_standard`;
      for (let key in keyValue) {
        // console.log('keyvalue: ', keyValue);
        if (key == 'class' && (keyValue[key] == '画册' || keyValue[key] == '色卡')) {
          newHost = `/py/erp/get_product_album`
        }
        if (keyValue[key]) {
          // 对应搜索关键词不为空时，才把关键词加入query字符串中
          query.push(`${key}=${keyValue[key]}`);
        }
      }
      if (usage) {
        query.push(`usage=${usage}`) // 用于购物车的请求，传入usage参数，控制不让0价格的商品返回到列表中
      }
      // console.log('修改后请求入参：',query)
      return request.get(`${newHost}?uid=${uid}&supplier_id=${supplierId}${query.length !==0 ? '&' : ''}${query.join('&')}&page=${page}`).then((res) => {
        if (res.data.data) {
          const count = res.data.data.total || 0;
          const list = res.data.data.list;
          return {
            count,
            list: list.map((item) => {
              item.inventory_remark = '';
              return item;
            })
          }
        }
      })
    },
    getInventoryList: (payload) => {
      return request.post(`/py/erp/get_inventory_list`, payload).then((res) => {
        return res.data;
      });
    },
    // 获取导入数据
    copySupplierCommodity: (payload) => {
      return request.post(`/py/erp/copy_supplier_commodity`, payload).then(res => {
        return res
      })
    },
    // 获取导入数据左侧的列表 http://ggtools.thinkerx.com/erp/get_copy_info
    getCopyInfo: (payload) => {
      return request.post(`/py/erp/get_copy_info`, payload).then(res => {
        return res.data
      })
    },
    // 搜索其他柜柜账号 http://ggtools.thinkerx.com/erp/add_copy_info
    addCopyInfo: (payload) => {
      return request.post(`/py/erp/add_copy_info`, payload).then(res => {
        return res.data;
      })
    },
    // 删除已经导入的供应商记录 http://ggtools.thinkerx.com/erp/delete_copy_info
    deleteCopyInfo: (payload) => {
      return request.post(`/py/erp/delete_copy_info`, payload).then(res => {
        return res.data
      })
    },
    // 获取订单详情
    getOrderDetail: (payload) => {
      return request.get(`/guigui/order/detail/${payload}`).then((res) => {
        return res.data;
      }).catch((err) => {
        return Promise.reject(err);
      })
    },
    // 新新版获取订单列表
    getNewOrderList: (payload) => {
      return request.post(`/py/erp/new_customer_list`, payload).then(res => {
        return res.data;
      }).catch((err) => {
        return Promise.reject(err)
      })
    },
    // 获取门窗柜规格分类列表
    getShutterList: (payload) => {
      return request.post('/py/erp/get_model_spec_list', payload).then(res => {
        return res.data;
      }).catch((err) => {
        return Promise.reject(err)
      })
    }
  }
}

export function getBill(supplierId, billId, uid) {
  // return axios.post(`${host}/py/erp/get_stock_bill`, {
  return axios.post(`${host}/py/erp/get_stock_bill`, {
    supplier_id: supplierId,
    stock_id: billId,
    uid
  }).then((res) => {
    if (res.data.data) {
      return res.data.data.stock_data[0];
    }
  })
}

export function getBillList(uid, supplierId, type, page, limit) {
  return axios.post(`${host}/py/erp/get_stock_bill`, {
    supplier_id: supplierId,
    order_type: type,
    uid,
    page,
    limit,
  }).then((res) => {
    if (res.data.data) {
      return {
        data: res.data.data.stock_data,
        total: res.data.data.total
      };
    }
  })
}

export function getObjectList(uid, supplierId, keyValue, page, usage) {
  keyValue.limit = keyValue.limit || 20;
  const query = [];
  let newHost = `${host}/py/erp/get_product_list`;
  for (let key in keyValue) {
    console.log('keyvalue: ', keyValue);
    if (key == 'class' && (keyValue[key] == '画册' || keyValue[key] == '色卡')) {
      newHost = `${host}/py/erp/get_product_album`
    }
    if (keyValue[key]) {
      // 对应搜索关键词不为空时，才把关键词加入query字符串中
      query.push(`${key}=${keyValue[key]}`);
    }
  }
  if (usage) {
    query.push(`usage=${usage}`) // 用于购物车的请求，传入usage参数，控制不让0价格的商品返回到列表中
  }
  return axios.get(`${newHost}?uid=${uid}&supplier_id=${supplierId}${query.length !==0 ? '&' : ''}${query.join('&')}&page=${page}`).then((res) => {
    if (res.data.data) {
      const count = res.data.data.total || 0;
      const list = processProductList(res.data.data.list);
      return {
        count,
        list
      }
    }
  })
}

export function saveBill(payload) {
  return axios.post(`${host}/py/erp/commodity_storage`, payload).then((res) => {
    if (res.data.status == 1) {
      return true;
    } else {
      return false;
    }
  })
}

export function getSupplierInfo(supplierId) {
  return axios.post(`${host}/guigui/cloudStorage/getSupplierInfo`, {
    id: supplierId
  }).then((res) => {
    if (res.data.data) {
      return res.data.data;
    }
  })
}

export function submitOrder(payload) {
  return axios.post(`${host}/py/erp/create_cloud_order_new`, payload).then((res) => {
    if (res.data.status == 1) {
      return res.data.data;
    } else {
      throw Error(res.data.data);
    }
  })
}

export function addManualOrder(payload) {
  return axios.post(`${host}/py/erp/add_manual_order`, payload).then((res) => {
    if (res.data.status == 1) {
      return res.data.data;
    } else {
      throw Error(res.data.data);
    }
  })
}
export function editManualOrder(payload){
  return axios.post(`${host}/py/erp/supplier_update_order`,payload).then(res => {
    console.log(res)

    if(res.data.status == 1){
      return res.data.data;
    }else{
      throw Error(res.data.data);
    }
  })
}

export function getPaymentLink(payload) {
  return axios.post(`${host}/py/erp/create_payment_new`, payload).then((res) => {
    if (res.data.status == 1) {
      return res.data.data;
    }
  })
}

export function getOrderStatus(payload) {
  return axios.post(`${host}/py/erp/check_order_status`, payload).then((res) => {
    if (res.data.status == 1) {
      return res.data.data;
    }
  })
}

export function getBasicMaterialList(userInfo, supplierInfo) {
  let query = `uid=${userInfo.id}&setting_type=plank_setting`
  if (supplierInfo) {
    query = `${query}&supplier_id=${supplierInfo.id}`
  }
  return axios.get(`${host}/py/erp/get_supplier_setting?${query}`).then((res) => {
    if (res.data.status == 1) {
      return res.data.data;
    }
  })
}

export function getClassList(userInfo, supplierInfo) {
  let query = `uid=${userInfo.id}&project=${encodeURIComponent('板材')}`
  if (supplierInfo) {
    query = `${query}&supplier_id=${supplierInfo.id}`
  }
  return axios.get(`${host}/py/erp/get_brand_list?${query}`).then((res) => {
    if (res.data.status == 1) {
      return res.data.data;
    }
  });
}

export function getFilterOptions(uid, sid, keyValue) {
  return
  const query = [`uid=${uid}`, `supplier_id=${sid}`];
  for (let key in keyValue) {
    console.log('get object list: ', keyValue);
    if (keyValue[key]) {
      // 对应搜索关键词不为空时，才把关键词加入query字符串中
      query.push(`${key}=${keyValue[key]}`);
    }
  }
  return axios.get(`${host}/py/erp/get_class_list?${query.join('&')}`).then((res) => {
    if (res.data.status == 1) {
      return res.data.data;
    }
  })
}

export function getClientList(uid, staffId) {
  return axios.post(`${host}/guigui/contact/customer_list`, {
    uid,
    type: -1,
    staff_id: staffId || 0,
  }).then((res) => {
    console.log('客户列表',res)
    if (res.data.status == 1) {
      return res.data.data;
    } else {
      return [];
    }
  })
}

export function getSupplierList(uid, search_key) {
  const payload = {
    page: 1,
    limit: 500, // 获取最大值，用户大多数情况会直接使用搜索，不会一项一项看，不用担心数据不全
    uid,
    search_key
  }
  return axios.post(`${host}/py/erp/supplier_management_get_vendor`, payload).then((res) => {
    if (res.data.status == 1) {
      return res.data.data.res;
    } else {
      return [];
    }
  })
}
export function sellerBuyerBindOrderId(payload){
  return axios.post(`${host}/py/erp/bind_order_id`,{
    commodity_list:payload
  }).then(res => {
    return res
  })

}
export function getSellerAndBuyerOrderDetail(payload){
  return axios.post(`${host}/py/erp/search_order`,payload).then(res => {
    return res
  })
}
// 根据ggid获取板件信息
export function getPlankOrderInfo(payload){
  let post_url;
  if(Array.from(payload)[0] != '÷'){
    payload = encodeURIComponent(payload)
    post_url = `http://guigui.thinkerx.com/order/QRcode/` + payload;
  }else{
    payload = payload.split('÷')[1]
    post_url = `http://guigui.thinkerx.com/exhibition/ggidTrans?ggid=` + payload;
  }
  return request.get(post_url).then(res => {
    return res
  })
}
// 获取所有包装箱以及包中板件(右边的模块)
export function getPcPackList(payload){
  return request.get(`/py/pc_get_pack_list`, payload).then(res => {
    return res
  })
}
// 获取项目任务列表(左边的模块)
export function getPcTaskList(payload){
  return request.get(`/py/pc_get_task_list`, payload).then(res => {
    return res
  })
}
// 获取项目所有板件列表(中间的模块)
export function getPcPlankList(payload){
  return request.get(`/py/pc_get_plank_list`, payload).then(res => {
    return res
  })
}
// 检查板件是否打包
export function CheckPcPlankStatus(payload){
  return request.post(`/py/pc_check_plank_status`, payload).then(res => {
    return res
  })
}
// 板件打包
export function packPcPlank(payload){
  return request.post(`/py/pc_pack_plank`, payload).then(res => {
    return res
  })
}
// 搜索板件
export function searchPcPlankInfo(payload){
  return request.post(`/py/pc_search_plank_info`, payload).then(res => {
    return res
  })
}
